import React from "react";

export default function MySQL_ATAN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_ATAN</h1>
      <p>This is the MySQL_ATAN component generated from the SQL JSON.</p>
    </div>
  );
}
